<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>الصيانات المتأخرة</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع العملاء المتأخرين المتأخر عمليات الصيانه لهم بين تاريخين
                              <div class='pull-left' style='padding=0px'>
                                <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                  <b> طباعة </b>
                                </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-12' style="margin:10px 0px;padding:0px">
                                <div class='col-lg-4 col-md-4 col-sm-6'>
                                      <label>الفرع</label>
                                      <select @change='FillItineraries()' class="form-control"  v-model="branch_id">
                                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                </div>
                                <div class='col-lg-4 col-md-4 col-sm-6'>
                                  <div class="form-group">
                                    <label>الخط</label>
                                    <vue-element-loading size='32' :active='isLoadingItineraries' spinner='bar-fade-scale' color='#A4A4A4'/>
                                    <select @change='FillRegions()' class="form-control" style="padding: 0px" v-model="itinerarie">
                                      <option v-for="item in itineraries" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <div class='col-lg-4 col-md-4 col-sm-6'>
                                  <div class="form-group">
                                    <vue-element-loading size='32' :active='isLoadingRegions' spinner='bar-fade-scale' color='#A4A4A4'/>
                                    <label>المنطقة</label>
                                    <select class="form-control" style="padding: 0px" v-model="region_id">
                                      <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.region_name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-6'>
                                  <tbDate :today='today' :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                                </div>
                                <div class='col-lg-3 col-md-3 col-sm-6'>
                                  <tbDate :today='today' :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                                </div>
                                    <div style="padding-top:25px" class='col-lg-3 col-md-3 col-sm-6'>
                                        <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                          <b> عرض </b>
                                        </button>
                                    </div>
                              </div>
                                    <div id="contentToPrint">
                                      <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                          <thead>
                                            <tr>
                                              <th style='padding:2px;text-align: center'>م</th>
                                              <th style='padding:2px;text-align: center'>الكود</th>
                                              <th style='padding:2px;text-align: center'>الاسم</th>
                                              <th style='padding:2px;text-align: center'>الخط</th>
                                              <th style='padding:2px;text-align: center'>التاريخ</th>
                                              <th style='padding:2px;text-align: center'>الصنف</th>
                                              <th style='padding:2px;text-align: center'>م صيانة</th>
                                              <th style='padding:2px;text-align: center'>م قسط</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <tr class='odd gradeX' v-for='(record,index) in record' :key='record.id'>

                                                 <td align='center'>{{index +1 }}</td>
                                                 <td align='center'>{{record.rec_id}}</td>
                                                 <td align='right'>{{record.customer_name}}</td>
                                                 <td align='center'>{{record.line_name}}</td>
                                                 <td align='center'>{{record.default_date}}</td>
                                                 <td align='center'>{{record.item}}</td>
                                                 <td align='center'>{{record.maintenance_ind}}</td>
                                                 <td align='center'>{{record.indebtedness}}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'MaintenanceArrears',
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      today: true,
      branches: {},
      record: {},
      branch_id: '',
      mainValidationErrors: '',
      isLoadingItineraries: false,
      isLoadingRegions: false,
      itineraries: {},
      itinerarie: 0,
      region_id: 0,
      regions: {},
      emptyRec: [{id: 0, name: ''}],
      isLoadingData: false
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = localStorage.getItem('BrancheID')
    this.FillItineraries()
  },
  methods: {
    FillRegions () {
      this.region_id = 0
      this.isLoadingRegions = true
      axios.post(this.$apiURL + 'get-branch-regions', {
        token: localStorage.getItem('token'),
        line: this.itinerarie
      })
        .then(res => {
          this.isLoadingRegions = false
          this.regions = res.data
          this.regions.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillItineraries () {
      this.regions = ''
      this.region_id = 0
      this.itinerarie = 0
      this.isLoadingItineraries = true
      axios.post(this.$apiURL + 'get-branch-itineraries', {
        token: localStorage.getItem('token'),
        branch: this.branch_id
      })
        .then(res => {
          this.isLoadingItineraries = false
          this.itineraries = res.data
          this.itineraries.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'maintenance-arrears', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        line_id: this.itinerarie,
        region_id: this.region_id,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.record = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.record = ''
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Reports/MaintenanceArrears.vue